import { apiClient } from '../services/api';

const onboardingCheckoutBaseUrl =
  process.env.REACT_APP_ONBOARDING_CHECKOUT_BASE_URL;

const url = (path) => `${(onboardingCheckoutBaseUrl || '').replace(/\/$/, '')}${path}`;

export const getCheckoutStateByProductInstanceId = async (pid) => {
  const response = await apiClient.get(url('/checkout-state/product-instance-id'), {
    params: { pid },
  });
  return response.data;
};

export const createCheckoutState = async (payload) => {
  const response = await apiClient.post(url('/checkout-state'), payload);
  return response.data;
};

export const updateCheckoutState = async (pid, payload) => {
  const response = await apiClient.put(url('/checkout-state'), payload, {
    params: { pid },
  });
  return response.data;
};
